import { Grid } from "@mui/material";
import React, { memo } from "react";
import { ContactType } from "./EditMerchantContactComponent";
import TextInput from "../../../common/formElements/TextInput";
import SelectDropDown, {
  Option,
} from "../../../common/formElements/SelectDropDown";

interface MerchantContactForm {
  index?: number;
  disabled?: boolean;
}

const MerchantContactForm = ({ index, disabled }: MerchantContactForm) => {
  const contactTypes: Option[] = [
    { [ContactType.PRIMARY]: "Primary" },
    { [ContactType.SECONDARY]: "Secondary" },
    { [ContactType.OTHER]: "Other" },
  ];

  return (
    <Grid container alignItems="flex-start" spacing={2}>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Contact[${index}].First`}
          label="First Name"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Contact[${index}].Last`}
          label="Last Name"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Contact[${index}].email`}
          label="Email"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Contact[${index}].Mobile`}
          label="Mobile"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Contact[${index}].Phone`}
          label="Phone"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectDropDown
          fieldname={`attributes.Contact[${index}].SortNumber`}
          label="Contact Type"
          options={contactTypes}
          disabled
        />
      </Grid>
    </Grid>
  );
};

export default memo(MerchantContactForm);
